export default __webpack_public_path__ + "static/media/lft-order-tracking-background.46151810.png";